module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-translation-action-buttons"
  }, [_c('button', {
    staticClass: "button warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Delete")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4aa8ac6c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/TranslationButtons.vue
// module id = 2456
// module chunks = 1